import {ModalAlertsDialog} from './ModalAlertsDialog'

export default ModalAlertsDialog
